import { yupResolver } from "@hookform/resolvers/yup";
import { getToday } from "api/constants";
import { GetDownloadCategories, PostDownloads, SignUpUser, UploadFile } from "api/endpoints";
import MEICKEditor from "components/ckeditor/MEICKEditor";
import FilePreviewer from "components/ckeditor/MEIFilePreview";
import MEILoader from "components/ckeditor/MEILoader";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";

import { Card, FloatingLabel, } from "react-bootstrap";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
import { FiUpload } from "react-icons/fi";
import { toast } from "react-toastify";
import * as yup from "yup";
// import ProductBasicInfo from "./add-product-tab/ProductBasicInfo";


const validatePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) {
    return true;
  }
  const regex = /^(?:\+92|92|0)3\d{2}\d{7}$/;
  return regex.test(phoneNumber);
};

const validateEmail = (email) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);
};

const schema = yup
  .object({
    fTitle: yup.string().required("User name is required."),
    eLink: yup.string().required("Email is required.").test('valid-email', 'Email is not valid.', validateEmail),
    smFB: yup.string().test('valid-phone', 'Phone Number is not valid.', validatePhoneNumber),
    fStatus: yup.string().required("Status is required."),

    fFile: yup.string(),

    password: yup.string().required("Password is required."),
    rtpassword: yup.string()
      .oneOf([yup.ref('password'), null], "Passwords must match") // This ensures rtpassword matches password
      .required("Retyped password is required."),
  })
  .required();

const initialForm = {
  fTitle: '',
  eLink: '',
  smFB: '',
  fStatus: 'true',
  fFile: '',
  password: '',
  rtpassword: '',


};

const ProductBasicInfo = ({ setLoading, loginId, perms, setPerms, initialPerms }) => {
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
    watch
  } = useFormContext();



  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {

      const allowedTypes = [
        'image/jpeg', // .jpg, .jpeg
        'image/png',  // .png
      ];
      if (!allowedTypes.includes(file.type)) {
        toast.error('Invalid File Format', {
          theme: "colored",
        });
        e.target.value = '';
        return
      }
      else {
        setLoading(true)
        const formData = new FormData();
        formData.append('file', file);

        UploadFile(formData).then(res => {
          // toast.success('File Uploaded Successfully!', {
          //   theme: "colored",
          // });
          setValue('fFile', res?.data)
          e.target.value = '';
          setLoading(false)

        }).catch(err => {
          setLoading(false)
          toast.error('File Uploading Failed', {
            theme: "colored",
          });
        });
      }

    }
  };

  return (
    <Row className="gx-2 gy-3">

      <Col md="12">
        <Form.Group>
          {/* <Form.Label>First name:</Form.Label> */}
          <FloatingLabel
            controlId="floatingInput"
            label="User Name"
            className=""
          >
            <Form.Control
              type="text"
              placeholder=""
              isInvalid={!!errors.fTitle}
              {...register("fTitle")}
            />
            <Form.Control.Feedback type="invalid">
              {errors.fTitle?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>



      <Col md="6">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Email Address" className="">
            <Form.Control
              type="text"
              placeholder=""
              isInvalid={!!errors.eLink}
              {...register("eLink")}
              disabled={loginId}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.eLink?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>


      <Col md="6">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Phone Number" className="">
            <Form.Control
              type="text"
              placeholder=""
              isInvalid={!!errors.smFB}
              {...register("smFB")}
            >

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.smFB?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>


      <Col md="6" style={{ position: 'relative' }}>

        <Form.Label style={{ left: 10, position: 'absolute', top: 0 }}>
          Profile Image (250 x 250)
        </Form.Label>
        <FilePreviewer accept=" .jpg, .jpeg, .png" furl={watch('fFile')} />


        <Form.Label htmlFor={`file-upload-us`} style={{ position: 'absolute', zIndex: 99, right: 20, top: '20%', cursor: 'pointer', textDecoration: 'underline' }} className="text-info">
          <FiUpload className="me-1" size={40} />
        </Form.Label>

        <Form.Control
          id={`file-upload-us`}
          type="file"
          style={{ width: '120px' }}
          onChange={(e) => handleFileChange(e)}
          className="d-none"
          accept=" .jpg, .jpeg, .png"
        />

      </Col>




      <Col md="6">
        <Form.Group>
          <FloatingLabel controlId="floatingInput" label="Status" className="">
            <Form.Control
              as="select"
              placeholder=""
              isInvalid={!!errors.fStatus}
              {...register("fStatus")}
            >
              <option value="true">Active</option>
              <option value="false">In-Active</option>

            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {errors.fStatus?.message}
            </Form.Control.Feedback>
          </FloatingLabel>
        </Form.Group>
      </Col>


      {
        !loginId &&
        <>
          <Col md="6">
            <Form.Group>
              <FloatingLabel controlId="floatingInput" label="Password" className="">
                <Form.Control
                  type="password"
                  placeholder=""
                  isInvalid={!!errors.password}
                  {...register("password")}
                >

                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.password?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Col>

          <Col md="6">
            <Form.Group>
              <FloatingLabel controlId="floatingInput" label="Re-Type Password" className="">
                <Form.Control
                  type="password"
                  placeholder=""
                  isInvalid={!!errors.rtpassword}
                  {...register("rtpassword")}
                >

                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.rtpassword?.message}
                </Form.Control.Feedback>
              </FloatingLabel>
            </Form.Group>
          </Col>
        </>
      }

      <div className="d-flex align-items-center mt-4 justify-content-between">

        <Form.Label className="">
          User Rights & Permissions
        </Form.Label>

        <Button
          variant="link"
          className="text-info fw-medium p-0 me-4"
          type="button"
          onClick={() => {

            setPerms(initialPerms)

          }}
        >
          Select All
        </Button>
      </div>

      {
        Object.keys(perms).map((perm, index) => (
          <Col md="4" key={index}>
            <Form.Group>
              <Form.Check
                type="checkbox"
                placeholder=""
                label={perm.replaceAll('Dreams', 'DREAMS')}
                checked={perms[perm]}
                onChange={e => setPerms({ ...perms, [perm]: e.target.checked })}
              />
            </Form.Group>
          </Col>
        ))
      }


    </Row>
  );
};


const AddUser = ({ handleDiscard, editData }) => {
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });
  const { handleSubmit, reset } = methods;

  const initialPerms = {
    'Profile Settings': true,
    'Users': true,
    'Home Slider': true,
    'Dreams Scope': true,
    'About Dreams Home': true,
    'Leadership': true,
    'Core Team': true,
    'Downloads': true,
    'Procurements': true,
    'News & Events': true,
    'Jobs': true,
    'Pages': true,
  }


  const [permissions, setPermissions] = useState({});


  useEffect(() => {
    if (editData?.loginId) {

      // const esdesc = JSON.parse(editData.description);
      reset({
        fTitle: editData.name,
        eLink: editData.loginId,
        smFB: editData.phoneNumber,
        fFile: editData.avatar,
        fStatus: editData.status.toString(),

        password: editData.loginId,
        rtpassword: editData.loginId,

      })

      const userPerms = JSON.parse(editData.permissions);
      const mergedPermissions = { ...initialPerms, ...userPerms };
      setPermissions(mergedPermissions);
      // setPermissions(userPerms);
    }
    else {
      reset(initialForm);
      setPermissions(initialPerms)
    }

  }, [editData])

  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    console.log(data);

    setLoading(true)

    const strPerms = JSON.stringify(permissions)

    const finalData = {
      // id: editData?.id ? editData?.id : 0,
      name: data.fTitle,
      loginId: data.eLink,
      phoneNumber: data.smFB,
      roleId: 0,

      avatar: data.fFile,
      status: data.fStatus === "true",

      permissions: strPerms,
      password: editData?.loginId ? '' : data.rtpassword,

    }

    SignUpUser(finalData).then(res => {

      toast.success('Data Saved Successfully', {
        theme: "colored",
      });
      setLoading(false)
      reset(initialForm)
      handleDiscard(true);

    }).catch(err => {

      toast.error('Data Saving Failed', {
        theme: "colored",
      });
      setLoading(false)
      console.log(err, 'PostDownloadsError')

    });


  };

  const handleDiscardPre = () => {
    reset(initialForm)
    handleDiscard();
  }

  return (
    <>

      <MEILoader showLoader={loading} />
      <FormProvider {...methods}>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="g-3">

            <Col lg={12}>
              <ProductBasicInfo setLoading={setLoading} loginId={editData?.loginId} perms={permissions} setPerms={setPermissions} initialPerms={initialPerms} />
            </Col>

            <Col xs={12}>
              <Row className="flex-between-center mt-3">
                <Col md>
                  {/* <h5 className="mb-2 mb-md-0">You're almost done</h5> */}
                </Col>
                <Col xs="auto">
                  <Button
                    variant="link"
                    className="text-secondary fw-medium p-0 me-3"
                    type="button"
                    onClick={handleDiscardPre}
                  >
                    Discard
                  </Button>
                  <Button variant="primary" type="submit" disabled={loading}>
                    {editData?.loginId ? 'Update' : 'Add'}
                  </Button>
                </Col>
              </Row>
            </Col>

          </Row>
        </Form>
      </FormProvider>
    </>
  );
};

export default AddUser;
